<template>
  <v-layout row wrap align-start fill-height pb-5>
    <v-flex xs12>
      <v-layout row wrap align-center mt-2 mb-2>
        <v-flex xs12>
          <v-card class="pa-2">
            <div class="d-inline-flex">
              <v-layout row align-center>
                <v-radio-group row v-model="blacklistType" class="pt-3 pl-2">
                  <v-radio
                      type="radio"
                      :label="$lang.labels.all"
                      value="all"/>
                  <v-radio
                      type="radio"
                      :label="$lang.labels.phone"
                      value="phone"/>
                  <v-radio
                      type="radio"
                      :label="$lang.labels.email"
                      value="email"/>
                </v-radio-group>
              </v-layout>
              <v-btn
                  :disabled="loading"
                  color="primary"
                  class="mx-0"
                  @click="searchBlacklist()">
                {{ $lang.labels.search }}
              </v-btn>
            </div>
            <v-flex xs12 pt-2 fill-height v-if="!blacklistResult || (blacklistResult && blacklistResult.length === 0)">
              <v-layout fow wrap>
                <v-flex xs12 v-if="loading">
                  <br>
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-flex>
                <v-flex xs12 v-if="err">
                  <v-alert
                      color="error"
                      class="err"
                      icon="warning"
                      value="true"
                      v-if="err">{{ err }}
                  </v-alert>
                </v-flex>
                <v-flex xs12 v-if="blacklistResult && blacklistResult.length === 0">
                  <v-alert
                      color="error"
                      class="err"
                      icon="warning"
                      value="true">No blacklist found.
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 pt-2 fill-height v-if="blacklistResult && blacklistResult.length > 0">
                <v-layout fow wrap>
                  <v-flex xs12>
                    <v-data-table
                        :headers="headers"
                        :items="blacklistResult"
                        disable-initial-sort
                        disable-sort
                    >
                      <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.value }}</td>
                        <td class="text-xs-left">{{ $lang.labels[props.item.type] }}</td>
                        <td class="text-xs-left">
                          <v-btn class="mx-0" color="primary" @click="removeBlacklist(props.item)">{{ $lang.actions.remove }}</v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog v-if="orderDetails" v-model="orderDetails" max-width="1200">
      <order-details :order="order" @close="orderDetails = false"/>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OrdersSearch',
  components: {
    orderDetails: () => import('../webshop/modals/OrderDetails'),
  },
  data() {
    return {
      order: null,
      orderDetails: false,
      searchType: 'orders',
      err: '',
      loading: false,
      blacklistResult: null,
      headers: [
        {
          text: this.$lang.header.value,
          align: 'left',
          sortable: false,
          value: 'value',
        },
        {
          text: this.$lang.header.type,
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: this.$lang.labels.actions,
          align: 'left',
          sortable: false,
          value: 'id',
        },
      ],
      blacklistType: 'all',
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters({
      company: 'company',
      companyActive: 'companyActive',
    }),
  },
  methods: {
    removeBlacklist(item) {
      this.$webHelper.post(`blacklist/delete/${item.id}`)
        .then((res) => {
          if (res.body && res.status === 200) {
            this.searchBlacklist();
          } else {
            this.err = res.body.statusText;
            setTimeout(() => {
              this.err = '';
            }, 6000);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
          this.loading = false;
        });
    },
    searchBlacklist() {
      this.blacklistResult = null;
      this.err = '';
      this.loading = true;
      this.$webHelper.get(`blacklist${this.blacklistType !== 'all' ? `?type=${this.blacklistType}` : ''}`)
        .then((res) => {
          if (res.body && res.status === 200) {
            this.blacklistResult = res.body.blacklist.sort((a, b) => {
              const keyA = new Date(a.createdOn);
              const keyB = new Date(b.createdOn);
              // Compare the 2 dates
              if (keyA > keyB) return -1;
              if (keyA < keyB) return 1;
              return 0;
            });
            setTimeout(() => {
              this.loading = false;
            }, 50);
          } else {
            this.err = res.body.statusText;
            setTimeout(() => {
              this.err = '';
            }, 6000);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.err = err;
          setTimeout(() => {
            this.err = '';
          }, 6000);
          this.loading = false;
        });
    },
  },
  created() {
    this.searchBlacklist();
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersAdmin/Blacklist.vue